import { usePatents } from 'src/patents/PatentsProvider'
import { IpRightsContext } from '../interfaces/IpRights'
import { createContext, useContext, useEffect, useState } from 'react'
import { IpRight } from '../interfaces/renewal_types'
import _ from 'lodash'
import { Member } from 'src/patents/patents'

export function DummyIpRightsProvider({ children }: { children: React.ReactNode }) {
  const { members, isLoading } = usePatents()
  const [ipRights, setIpRights] = useState([] as IpRight[])
  useEffect(() => {
    if (!isLoading) {
      const ipRights = members.flatMap((member, i) => {
        if (i % 2 === 0) return []
        return [
          {
            id: '' + i,
            clientReference: member.internalReference,
            clientUniqueId: '' + member.familyMemberId,
            publicationNumber: member.publicationNumber,
            grantNumber: member.patentNumber,
            status: member.familyMemberStatus === 'stopped' ? 'Expired' : 'Ready',
            costCenters: {},
            owner: 0,
          } as IpRight,
        ]
      })
      setIpRights(ipRights)
    }
  }, [isLoading, members])

  function _postIpRight(ipRight: IpRight, familyMemberId?: number) {
    const current = ipRights.findIndex((ir) => ir.clientUniqueId === ipRight.clientUniqueId)
    if (current < 0) {
        console.log({size: ipRights.length})
        setIpRights([...ipRights, {...ipRight, id: '' + familyMemberId}])
    } else {
        const newIpRights = [...ipRights]
        newIpRights[current] = { ...newIpRights[current], ...ipRight }
        setIpRights(newIpRights)
    }
  }
  function postIpRight(ipRight: IpRight, familyMemberId?: number) {
    _postIpRight(ipRight, familyMemberId)
    return Promise.resolve()
  }
  //function postIpRights(ipRights: { ipRight: IpRight; familyMemberId?: number }[]) {
  //  ipRights.forEach(({ ipRight, familyMemberId }) => {
  //    _postIpRight(ipRight, familyMemberId)
  //  })
  //  return Promise.resolve()
  //}

  async function stopIpRight(ipRight: IpRight) {
    _postIpRight({ ...ipRight, status: 'Stopped' })
  }

  function deriveInitial(member: Member) {
    return {
      clientReference: member.internalReference,
      clientUniqueId: '' + member.familyMemberId,
      publicationNumber: member.publicationNumber,
      grantNumber: member.patentNumber,
    }
  }

  const ipRightById = _.keyBy(ipRights, 'id')
  const ipRightByFamilyMemberId = _.keyBy(ipRights, 'clientUniqueId')

  const value = {
    ipRights,
    // postIpRight,
    // postIpRights,
    stopIpRight,
    // deriveInitial,
    ipRightById,
    ipRightByFamilyMemberId,
  } // TODO

  return (
    <IpRightsContext.Provider {...{ value }}>
      <DummyIpRightsContext.Provider value={{ postIpRight, deriveInitial }}>{children}</DummyIpRightsContext.Provider>
    </IpRightsContext.Provider>
  )
}

const DummyIpRightsContext = createContext({
    postIpRight: (ipRight: IpRight, familyMemberId?: number) => Promise.resolve(),
    deriveInitial: (member: Member) => ({} as Partial<IpRight>),
})

export function useDummyIpRights() {
    return useContext(DummyIpRightsContext)
}
